import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import NotFound from "./components/NotFound";
import About from "./components/About";
import Privacy from "./components/Privacy";
import Eula from "./components/Eula";
import Disconnect from "./components/Disconnect";
import App from "./App";

const Router = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/founder" component={About} />
      <Route exact path="/privacy" component={Privacy} />
      <Route exact path="/eula" component={Eula} />
      <Route exact path="/disconnect" component={Disconnect} />
      <Route exact path="/" component={App} />
      <Route component={NotFound} />
    </Switch>
  </BrowserRouter>
);

export default Router;
